import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const AdminFooter = () => (
  <Footer className="AdminFooter">
    <span>wTrips - by Walmor Moreira</span>
  </Footer>
);

export default AdminFooter;
